<script>
import Multiselect from 'vue-multiselect'

export default {
	name: 'FishingYearSelector',
	props: {
		title: {
			type: String,
			default: '',
		},
		subtitle: {
			type: String,
			default: '',
		},
		errors: {
			type: Object,
			default: null,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		required: {
			type: Boolean,
			default: false,
		},
		modelValue: {
			type: Object,
			default: null,
		},
	},
	components: {
		Multiselect,
	},
	emits: ['update:modelValue', 'change'],
	data() {
		return {
			fishingYearOptions: [
				{
					label: '1.07.2024 - 30.06.2025',
					start: '2024-07-01',
					finish: '2025-06-30',
				},
				{
					label: '1.07.2025 - 31.12.2025',
					start: '2025-07-01',
					finish: '2025-12-31',
				},
				{
					label: '01.01.2026 - 31.12.2026',
					start: '2026-01-01',
					finish: '2026-12-31',
				},
			],
		}
	},
	computed: {
		selectedValue: {
			get() {
				return this.modelValue || this.fishingYearOptions[this.fishingYearOptions.length - 1] // Default to second option
			},
			set(value) {
				this.$emit('update:modelValue', value)
				this.$emit('change', value)
			},
		},
	},
	mounted() {
		// Set default value if none provided — pick the last (newest) period
		if (!this.modelValue) {
			this.selectedValue = this.fishingYearOptions[this.fishingYearOptions.length - 1]
		}
	},
}
</script>

<template>
	<div
		class="fishing-year-input-wrapper w-full sm:w-auto sm:max-w-[200px] md:max-w-[220px] lg:max-w-[240px] xl:max-w-[260px]"
	>
		<div v-if="title" class="fishing-year-title text-[10px] sm:text-[12px]">
			{{ title }}
			<span v-if="subtitle">
				<br />
				{{ subtitle }}
			</span>
		</div>
		<div
			class="fishing-year-input-body"
			:class="{ 'fishing-year-input-body--error': errors && errors.$error }"
		>
			<multiselect
				v-model="selectedValue"
				:options="fishingYearOptions"
				:track-by="'start'"
				:label="'label'"
				:max-height="200"
				:preserve-search="true"
				:required="required"
				:disabled="disabled"
				:close-on-select="true"
				class="fishing-year-multiselect__check"
				placeholder="Выберите период"
			>
				<template slot="singleLabel" slot-scope="{ option }">{{ option.label }}</template>
				<template slot="noResult">{{ $t('components.not_found') }}</template>
				<template slot="noOptions">{{ $t('components.not_found') }}</template>
				<template slot="placeholder">Выберите период</template>
			</multiselect>
		</div>
		<div v-if="errors && !errors.required" class="fishing-year-input-required">
			{{ $t('system_message.required_message') }}
		</div>
	</div>
</template>

<style>
.fishing-year-input-wrapper {
	width: 100%;
}

.fishing-year-title {
	font-weight: 600;
	color: #0a091d;
	margin-bottom: 8px;
	line-height: 1.2;
}

.fishing-year-title span {
	color: #708295;
}

.fishing-year-input-body {
	position: relative;
	z-index: 100;
}

.fishing-year-input-body .multiselect__tags {
	padding-left: 15px;
	border: 1px solid #52a5fc !important;
	border-radius: 5px;
	background: #ffffff;
	font-weight: 400;
	font-size: 12px;
	color: #0a091d;
	line-height: 1.2;
	width: 100%;
	min-height: 35px;
}

@media (min-width: 640px) {
	.fishing-year-input-body .multiselect__tags {
		padding-left: 20px;
		font-size: 14px;
		min-height: 41px;
	}
}

.fishing-year-input-body .multiselect--disabled .multiselect__tags {
	border: 1px solid #d3e7fb;
}

.fishing-year-input-body .multiselect--disabled .multiselect__placeholder {
	margin-bottom: 0;
}

.fishing-year-input-body .multiselect__single {
	margin-bottom: 0;
}

.fishing-year-input-body--error .multiselect__tags {
	border: 1px solid #ec3439 !important;
}

.fishing-year-input-required {
	color: #ec3439;
	font-size: 10px;
	margin-top: 4px;
}

@media (min-width: 640px) {
	.fishing-year-input-required {
		font-size: 12px;
	}
}

/* Additional multiselect styling to match existing design - absolute so dropdown overlays and does not push parent height */
.fishing-year-multiselect__check .multiselect__content-wrapper {
	border: 1px solid #52a5fc;
	border-top: none;
	border-radius: 0 0 5px 5px;
	z-index: 100;
	position: absolute;
}

.fishing-year-multiselect__check .multiselect__option {
	padding: 8px 15px;
	font-size: 12px;
	color: #0a091d;
}

@media (min-width: 640px) {
	.fishing-year-multiselect__check .multiselect__option {
		padding: 10px 20px;
		font-size: 14px;
	}
}

.fishing-year-multiselect__check .multiselect__option--highlight {
	background: #52a5fc;
	color: white;
}

.fishing-year-multiselect__check .multiselect__option--selected {
	background: #d3e7fb;
	color: #0a091d;
}

/* Responsive adjustments */
@media (max-width: 640px) {
	.fishing-year-input-body .multiselect__tags {
		padding-left: 12px;
		font-size: 11px;
		min-height: 32px;
	}

	.fishing-year-multiselect__check .multiselect__option {
		padding: 6px 12px;
		font-size: 11px;
	}

	.fishing-year-title {
		font-size: 9px;
	}

	.fishing-year-input-required {
		font-size: 9px;
	}
}
</style>
